import { useTheme } from '@mui/material/styles';
import { CheckCircleOutline } from '@mui/icons-material';
import { formatToAmount } from '@qrios/frontend-library';

import locales from '../../../../../../../../constants/locales';
import DetailsList from '../../../../../../../common/details-list';
import DetailsFactory from '../../../../../../../common/details-list/detailsFactory';
import { formatDate, TABLE_DATE_TIME_FORMAT } from '../../../../../../../../constants/helpers/dates';

import creditTypesMapperToString from '../../../../../../../../constants/validation/creditTypesToString';
import {
  PAYMENT_METHODS,
  WalletCreditInfoResponse
} from '../../../../../client-balance/add-funds-to-your-wallet/interfaces';

interface Props {
  credit: WalletCreditInfoResponse;
}

const ConfirmedCredit = ({ credit }: Props) => {
  const theme = useTheme();
  const { details } = credit.info;

  const detailsDependingOnTheDetailsMessage = () => {
    switch (credit.info.creditType) {
      case credit.info.details.detailsMessage && PAYMENT_METHODS.EXTERNAL_BANK_TRANSFER_ACCESS:
        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.transferNarration,
                value: details.transferTitle
              },
              { label: locales.operation.label.accountNumberIban, value: details.bankAccountNumber },
              {
                label: locales.operation.label.transferAmount,
                value: credit.info.creditAmount ? formatToAmount(credit.info.creditAmount.value) : '-'
              },
              {
                label: locales.operation.label.bankName,
                value: details.bankName
              },
              {
                label: locales.operation.label.confirmedCreditAmount,
                value: credit.info.details.confirmedCreditAmount
                  ? formatToAmount(credit.info.details.confirmedCreditAmount.value)
                  : '-'
              },
              {
                label: locales.operation.label.confirmDate,
                value: credit.info.confirmDate && formatDate(credit.info.confirmDate, TABLE_DATE_TIME_FORMAT)
              },
              {
                label: locales.operation.label.type,
                value: creditTypesMapperToString(credit.info.details.type)
              },
              {
                label: locales.operation.label.detailsMessage,
                value: credit.info.details.detailsMessage
              }
            ]}
          />
        );
      case PAYMENT_METHODS.MANUAL_CREDIT:
        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.transferAmount,
                value: credit.info.creditAmount ? formatToAmount(credit.info.creditAmount.value) : '-'
              },
              {
                label: locales.operation.label.type,
                value: creditTypesMapperToString(credit.info.details.type)
              }
            ]}
          />
        );
      default:
        return (
          <DetailsList
            items={[
              {
                label: locales.operation.label.transferNarration,
                value: details.transferTitle
              },
              { label: locales.operation.label.accountNumberIban, value: details.bankAccountNumber },
              {
                label: locales.operation.label.transferAmount,
                value: credit.info.creditAmount ? formatToAmount(credit.info.creditAmount.value) : '-'
              },
              {
                label: locales.operation.label.bankName,
                value: details.bankName
              },
              {
                label: locales.operation.label.confirmedCreditAmount,
                value: credit.info.details.confirmedCreditAmount
                  ? formatToAmount(credit.info.details.confirmedCreditAmount.value)
                  : '-'
              },
              {
                label: locales.operation.label.confirmDate,
                value: credit.info.confirmDate && formatDate(credit.info.confirmDate, TABLE_DATE_TIME_FORMAT)
              },
              {
                label: locales.operation.label.type,
                value: creditTypesMapperToString(credit.info.details.type)
              }
            ]}
          />
        );
    }
  };

  return (
    <DetailsFactory
      header={{
        icon: { component: CheckCircleOutline, color: theme.palette.success.main },
        id: credit.info.operationId,
        date: credit.info.attemptDate,
        status: credit.info.creditStatus
      }}
      operationContent={detailsDependingOnTheDetailsMessage()}
    />
  );
};

export default ConfirmedCredit;
